import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { Dropdown } from '@amzn/storm-ui';
import { noop } from '@amzn/storm-ui-utils';
import { w as withFilter } from './withFilter-CXO9aEFY.js';

const DEFAULT_OPTION = {
  shouldSort: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['label', 'value']
};
const FilterDropdownBody = withFilter(Dropdown);
const FilterDropdown = ({
  placeholder = '',
  onFilterChange = noop,
  onFilterClear = noop,
  onOpen = noop,
  clearButtonLabel = 'Clear search terms',
  options = DEFAULT_OPTION,
  transparentButton = false,
  mobileFullScreen = false,
  secondaryViewCloseButtonLabel = 'Done',
  persistFilterState = false,
  focusSelected = false,
  openDirection = 'bottom',
  forceDirection = false,
  ...restProps
}) => /*#__PURE__*/React.createElement(FilterDropdownBody, _extends({}, restProps, {
  placeholder: placeholder,
  onFilterChange: onFilterChange,
  onFilterClear: onFilterClear,
  onOpen: onOpen,
  clearButtonLabel: clearButtonLabel,
  options: options,
  transparentButton: transparentButton,
  mobileFullScreen: mobileFullScreen,
  secondaryViewCloseButtonLabel: secondaryViewCloseButtonLabel,
  persistFilterState: persistFilterState,
  focusSelected: focusSelected,
  openDirection: openDirection,
  forceDirection: forceDirection
}));

// To have Dropdown recognizes FilterDropdown, need to set displayName to "Dropdown"
FilterDropdown.displayName = 'Dropdown';

export { FilterDropdown as F };
//# sourceMappingURL=FilterDropdown-CoynaBwb.js.map
